<template>
    <div style="padding: 20px; height:800px; overflow: auto;padding-bottom:300px">
        <Tabs  v-model="thisname">
             <Row slot="extra" style="width: 500px; position: relative; top:10px" v-if="thisname=='name1'">
                <Col span="5">总帐户数：<strong class="result">{{bankList.length}}</strong></Col>
                <Col span="10">总金额：  <strong class="result">{{allmoney.toFixed(2)}}</strong></Col>
            </Row>
            <TabPane label="结算账户" name="name1">
                <ul class="card">
                    <li v-for="(item,index) in bankList" :key="index">
                        <p>账户余额：<strong class="result">{{item.money}}</strong></p>
                        <p  v-if="item.type==1">账户类型：现金</p>
                        <p  v-if="item.type==2">账户类型：银行卡</p>
                        <p  v-if="item.type==3">账户类型：支付宝</p>
                        <p  v-if="item.type==4">账户类型：微信</p>
                        <p  v-if="item.type==5">账户类型：其他</p>
                        <p  v-if="item.type==6">账户类型：会员卡</p>
                        <p>建立时间：{{item.time}}</p>
                        <div class="tagTab" style="background:rgba(255,175,94,1);" v-if="item.type==1">{{item.bankname}}</div>
                        <div class="tagTab" style="background:rgba(94,140,255,1);" v-if="item.type==2">{{item.bankname}}</div>
                        <div class="tagTab" style="background:rgba(255,135,94,1);" v-if="item.type==3">{{item.bankname}}</div>
                        <div class="tagTab" style="background:rgba(87,180,129,1);" v-if="item.type==4">{{item.bankname}}</div>
                        <div class="tagTab" style="background:rgba(255,127,157,1);;" v-if="item.type==5">{{item.bankname}}</div>
                        <div class="tagTab" style="background:rgba(255,127,157,1);;" v-if="item.type==6">{{item.bankname}}</div>
                        <Dropdown class="more">
                            <a href="javascript:void(0)">
                                <Icon type="md-more" size="20" />
                            </a>
                            <DropdownMenu slot="list" trigger="click">
                                <DropdownItem>
                                    <div @click="$router.push({path:'/consumption',query:{id:item.type}})">账户流水</div>
                                </DropdownItem>
                                <DropdownItem>
                                    <div  @click="$router.push({path:'/putbill'})">记一笔</div>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </li>
                    <li @click="addAccountGl=true">
                        <img src="../../assets/img/bankcard.png" style="display: block;margin:auto"/>
                        <p style="text-align: center">添加账户</p>
                    </li>
                </ul>
            </TabPane>
            <TabPane label="记一笔账目类型" name="name2">
                <Alert v-for="(item,index) in sendTypeList" v-if="item.name!='销售收入'&&item.name!='采购支出' &&item.name!='销售退货'&&item.name!='采购退货'" :key="index" >{{item.name}}</Alert>
            </TabPane>
        </Tabs>

        <Modal
                v-model="addAccountGl"
                title="添加账户">
            <Form :label-width="80" style="width: 90%" >
                <FormItem label="账户类型">
                    <Select v-model="formSelect.type" class="formSelect-input" placeholder="请选择账户类型 (必填)">
                        <Option :value="k.type" v-for="(k,v) in bankListitem" :key="v"  >{{k.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem label="名称">
                    <Input v-model.trim="formSelect.name" :maxlength="32"  class="formSelect-input" :disabled="ishuiyuank" placeholder="请输入账户名称 (必填)" />
                </FormItem>
                <FormItem label="账号">
                    <Input v-model.trim="formSelect.account" type="number" class="formSelect-input" placeholder="请输入账号" />
                </FormItem>
                <FormItem label="开户人">
                    <Input v-model.trim="formSelect.username" :maxlength="20"  class="formSelect-input" placeholder="请输入开户人" />
                </FormItem>
                <FormItem label="门店">
                    <Input v-model="formSelect.store"  :maxlength="32"  class="formSelect-input" disabled />
                </FormItem>
                <FormItem label="是否启用">
                    <i-switch v-model="formSelect.isopen">
                        <span slot="open">On</span>
                        <span slot="close">Off</span>
                    </i-switch>
                </FormItem>
                <FormItem label="备注">
                    <Input v-model="formSelect.desc" :maxlength="50" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="备注"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="add()" :loading="loading">
                    <span v-if="!loading">添加 </span>
                    <span v-else>添加中 </span>
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                cid:"",
                sid:'',
                bankList:[],
                ishuiyuank:false,
                bankListitem:[
                    {name:'现金',type:1},
                    {name:'银行卡',type:2},
                    {name:'支付宝',type:3},
                    {name:'微信钱包',type:4},
                    {name:'会员卡',type:6},
                    {name:'其他',type:5},
                ],
                allmoney:0,
                sendTypeList:[],
                addAccountGl:false,
                loading:false,
                formSelect:{
                    type:'',
                    name:'',
                    account:'',
                    username:'',
                    store:JSON.parse(localStorage.getItem('shop')).name,
                    isopen:true,
                    desc:'',
                },
                thisname:'name1'
            }
        },

        watch: {
            'formSelect.type': {
                deep: true,
                handler: function (newVal,oldVal){
                     if(newVal==6){
                         for(var i=0;i<this.bankList.length;i++) {
                             if(this.bankList[i].type==newVal){
                                 this.$Message.warning('当前已有会员账户，请勿重复添加');
                                 this.formSelect.type=''
                                 break;
                             }
                         }
                     }

                    if(newVal==6){
                        this.formSelect.name='会员卡'
                        this.ishuiyuank=true
                    }else {
                        this.formSelect.name=''
                        this.ishuiyuank=false
                    }
                }
            },
            "formSelect.account": {
                deep: true,
                handler: function (newVal, oldVal) {
                    if(newVal.length>18){

                        this.formSelect.account = this.formSelect.account.substr(0,17)
                        var thisstr=this.formSelect.account

                        this.formSelect.account=''
                        this.formSelect.account=thisstr

                       //
                    }
                },
            }
        },
        created: function() {
            //DOM更新完之前请求数据
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            this.getBankList()
            this.getTradetypeList()
        },
        methods: {
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                       this.bankList =  res.data
                        res.data.forEach((item,index)=>{
                            this.allmoney+=item.money
                        })
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
             //结算类型
            getTradetypeList(){
                this.$Api.getTradetypeList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.sendTypeList =  res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            add(){
               if(this.formSelect.type==''){
                   this.$Message.warning('请选择账户类型');
                   return;
               }
                if(this.formSelect.name==''){
                    this.$Message.warning('请输入账户名称');
                    return;
                }
                if(!this.formSelect.isopen){
                    this.$Message.warning('请先启用');
                    return;
                }
                var isdel
                if(this.formSelect.isopen){
                    isdel=0
                }else {
                    isdel=1
                }
                this.loading=true
                this.$Api.addBank({
                    cid: this.cid,
                    sid: this.sid,
                    bankname: this.formSelect.name,
                    bankcode: this.formSelect.account,
                    principal: this.formSelect.username,
                    remark: this.formSelect.desc,
                    type: this.formSelect.type,
                    isdel:isdel //qingyuong 1jinyong
                }).then(res => {
                    if(res.code==200){
                        this.sendTypeList =  res.data
                        this.addAccountGl=false
                        this.formSelect.type=''
                        this.formSelect.name=''
                        this.formSelect.account=''
                        this.formSelect.username=''
                        this.formSelect.desc=''
                        this.formSelect.isopen=true
                        this.getBankList()
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loading=false
                });


            },

        }
    }
</script>


<style  lang="scss" scoped>
    .server-title{
        display: inline-block;
        text-align: center;width: 88%
    }
    .logo{
        width: 50px;
        height: 50px;
        margin: auto;
    }
.ivu-form-item{
    height: 30px;
}
    .result{
        color: red;
    }
    .card{
        margin-top: 50px;
        padding-top: 30px;
    }
    .card>li{
        width:290px;
        height:110px;
        background:rgba(255,255,255,1);
        border-radius:5px;
        box-shadow: 0px 3px 10px 0px rgba(24, 54, 129, 0.2);
        cursor: pointer;
        margin:0 50px 50px 30px;
        padding: 15px;
        line-height: 26px;
        position: relative;
        float: left;
    }
    .card>li>.tagTab{
        position: absolute;
        top: -24px;
        width:50px;
        text-align: center;
        line-height: 24px;
        height:24px;
        background:rgba(255,255,255,1);
        border-top-left-radius:3px;
        border-top-right-radius:3px;
        color: #ffffff;
        font-size: 12px;
    }
    .card{
        li{
            .more{
                position: absolute;
                right: 20px;
                top: 10px;
            }
        }
    }
</style>